import { render, staticRenderFns } from "./StudentSettingsDialog.vue?vue&type=template&id=5d6586e4&scoped=true"
import script from "./StudentSettingsDialog.vue?vue&type=script&lang=js"
export * from "./StudentSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./StudentSettingsDialog.vue?vue&type=style&index=0&id=5d6586e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6586e4",
  null
  
)

export default component.exports